import $ from 'wee-dom';
import $mediator from 'wee-mediator';
import { _html, _body } from 'core/variables';

export default class MobileSearch {
    constructor() {
        /**
         * The main navigation element
         * @member {$}
         */
        this.$el = $(':mobileSearch');

        /**
         * The button to open the mobile search
         * @member {$}
         */
        this.$button = $(':mobileSearchToggle');

        /**
         * Wee selection of the HTML element
         * @member {$}
         */
        this.$html = $(_html);

        /**
         * The site header
         * @member {$}
         */
        this.$siteHeader = $(':siteHeaderMain');

        /**
         * The internal open state
         * @member {boolean}
         */
        this.isOpen = false;
    }

    /**
     * Open the navigation
     *
     * @return {this}
     */
    open() {
        this.operate();

        return this;
    }

    /**
     * Close the navigation
     *
     * @return {this}
     */
    close() {
        this.operate(false);

        return this;
    }

    /**
     * Toggle the navigation
     *
     * @return {this}
     */
    toggle() {
        this.operate(! this.isOpen);

        return this;
    }

    /**
     * Operate the navigation
     *
     * @param {boolean} state - The current 'open' state of the navigation
     */
    operate(state = true) {
        this.$el[state ? 'activate' : 'deactivate']()
            .ariaHidden(! state);
        this.$html[state ? 'disable' : 'enable']();
        this.$siteHeader[state ? 'activate' : 'deactivate']();
        this.$button.ariaExpand(state);
        this.isOpen = state;

        $mediator.emit('search.mobile.operate', state);
    }
}
